import React from "react";
import { Styles } from "./styles";
import Loader from "../../../../common/loader/Loader";
import { t } from "i18next";
import { useSelector } from "react-redux";
import Pulse from 'react-reveal/Pulse';

const HeaderFloatingCardBeforeLogin = ({
  studentsCount,
  lecturesCount,
  activitiesCount,
  isLoading,
}) => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  return (
    <Styles>
      <div className="floating-card">
        {isLoading ? (
          <Loader height={"90px"} paddingTop={"0"} />
        ) : (
          <>
            <Pulse>
              <div className="item">
                <div className="count">{studentsCount}</div>
                <div className="name">
                  {Resource?.student ? Resource?.student : t("courses.student")}
                </div>
              </div>
            </Pulse>
            <Pulse>
              <div className="item">
                <div className="count">{lecturesCount}</div>
                <div className="name">
                  {Resource?.lecture
                    ? Resource?.lecture
                    : t("activities.lecture")}
                </div>
              </div>
            </Pulse>
            <Pulse>
              <div className="item">
                <div className="count">{activitiesCount}</div>
                <div className="name">
                  {Resource?.activity
                    ? Resource?.activity
                    : t("courses.activity")}
                </div>
              </div>
            </Pulse>
          </>
        )}
      </div>
    </Styles>
  );
};

export default HeaderFloatingCardBeforeLogin;
